import React, { FC } from 'react'
import { Wrapper, Element } from './styled'

export const AdvantagesComponent: FC = () => (
	<Wrapper>
		<Element
			title="Откроем счет как&nbsp;вам&nbsp;удобно"
			text="Приедем к&nbsp;вам или&nbsp;пригласим в&nbsp;любой из&nbsp;наших уютных офисов"
		/>
		<Element
			title="Предоставим любой тариф на&nbsp;месяц за&nbsp;0&nbsp;₽"
			text="Можете попробовать готовый тариф или&nbsp;настроить свой"
		/>
		<Element
			title="Подключим нужные сервисы бесплатно"
			text="Мы выбрали основные, которые пригодятся на&nbsp;старте, но&nbsp;у&nbsp;нас есть&nbsp;еще"
		/>
	</Wrapper>
)
